// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hhrWc","textarea":"styles_textarea__2-LG1"};